import { FileUploadField } from './fileUpload/fileUpload.writer';
import { TableEditorField } from '@/components/forms/components/form/writer/fields/tableEditor/tableEditor.writer';
import { ComponentType } from 'react';
import { RegistryFieldsType } from '@rjsf/utils';
import { withInlineValidation } from '@/components/forms/wrappers/withInlineValidation';

export const fields = {
  FileUploadField: withInlineValidation(FileUploadField as any),
  DataEditorWidget: TableEditorField
} as const satisfies Record<
  string,
  ComponentType<any>
> as unknown as RegistryFieldsType;
